/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DbChangeSet,
} from '../models/index';
import {
    DbChangeSetFromJSON,
    DbChangeSetToJSON,
} from '../models/index';

/**
 * 
 */
export class DBChangesControllerApi extends runtime.BaseAPI {

    /**
     */
    async getDatabaseChangesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DbChangeSet>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("SecurityScheme", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admsys/db-changes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DbChangeSetFromJSON));
    }

    /**
     */
    async getDatabaseChanges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DbChangeSet>> {
        const response = await this.getDatabaseChangesRaw(initOverrides);
        return await response.value();
    }

}
